import React, { Component } from "react";
import S from "./FundSingle.styled";
import FundTabNavigation from "./sub-components/FundTabNavigation";
import CurrentFundTabComponentsRenderer from "./sub-components/CurrentFundTabComponentsRenderer";

export interface FundSingle {}

const FundSingle: React.FC<FundSingle> = () => {
    return (
    <S.FundSingleWrapper>
        <FundTabNavigation/>
        <S.FundSingleWrapperInner id="fundComponent">
            <CurrentFundTabComponentsRenderer/>
        </S.FundSingleWrapperInner>
    </S.FundSingleWrapper>
    );
};

export default FundSingle;
